export const internalUrls = ['moonbeam.foundation', 'moonbeam.network'];

const forumURL = 'https://forum.moonbeam.foundation';

export const openGovForumURL = `${forumURL}/c/governance/2`;
